export default __webpack_public_path__ + "static/media/movement.baec5906.svg";